import React, { PropsWithChildren } from 'react';

import clsx from 'clsx';

import classes from './list.module.scss';

type Props = PropsWithChildren<{ className?: string; enumerated?: boolean }>;

export const List = ({ className, children, enumerated }: Props) => {
  return React.createElement(
    enumerated ? 'ol' : 'ul',
    {
      className: clsx(
        classes.list,
        enumerated && classes.enumerated,
        className,
      ),
    },
    children,
  );
};
